import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import {Amplify} from "aws-amplify";
import awsconfig from "./aws-exports";
import {PrimeReactProvider, PrimeReactContext} from 'primereact/api';
import {createRoot} from 'react-dom/client';

Amplify.configure(awsconfig.Cognito);
const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(<React.StrictMode>
    <PrimeReactProvider><App/></PrimeReactProvider>
</React.StrictMode>);

